module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-wrapper"
  }, [_c('form', {
    ref: "form",
    attrs: {
      "data-vv-scope": _vm.scope
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._t("default"), _vm._v(" "), _c('button', {
    ref: "submitBtn",
    class: _vm.submitBtnClasses,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.submitBtnComputedText))])], 2), _vm._v(" "), _c('div', {
    ref: "mask",
    staticClass: "mask"
  }), _vm._v(" "), _c('i', {
    ref: "spinner",
    staticClass: "fa fa-refresh fa-spin fa-3x fa-fw spinner"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-554cf694"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExtForm.vue
// module id = 231
// module chunks = 1